export interface UserLoginInfo {
  username: string;
  name?: string;
  email?: string;
  picture?: string;
  groups: GroupType[];
  userId: string;
  loginProvider?: string;
}

export enum GroupType {
  AGENCY = 'agency',
  CCC = 'ccc',
  PRIVATE = 'private',
}
